module.exports = __webpack_public_path__ + "static/media/tstm-emilson-cribari.6cb8bd80.png";